import CustomViewOptionCustomSection from "csi/middleware/customView/options/CustomViewOptionCustomSection";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useCustomViewDialogStore } from "../../csi/middleware/customView/CustomViewDialogStore";
import TimelineCustomViewOptionsStore from "./TimelineCustomViewOptionsStore";
import TimelineOptions from "./TimelineOptions";

const TimelineViewOptions: FunctionComponent = observer(function TimelineViewOptions() {
	const { optionsStore } = useCustomViewDialogStore();

	const {
		toggleCollapsedViewSpecificOptions,
		viewSpecificOptionsCollapse,
	} = optionsStore as TimelineCustomViewOptionsStore;

	return (
		<CustomViewOptionCustomSection
			collapsed={viewSpecificOptionsCollapse}
			dataCsiAutomation="CustomViewTimelineOptions"
			onCollapse={toggleCollapsedViewSpecificOptions}
			titleRes="CustomViewTimelineOptions"
		>
			<TimelineOptions />
		</CustomViewOptionCustomSection>
	);
});

export default TimelineViewOptions;